import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router';
import { monitoring_systems as MONITORING_SYSTEMS } from '../../constants/data_types'
import { Link } from 'react-router-dom';
import {
  getBluejayTeam as onGetBluejayTeam,
  getTeamAlcomScores as onGetTeamAlcomScores,
  getUnmappedResourceAlcomScores as onGetUnmappedResourceAlcomScores,
  getServiceAlcomScores as onGetServiceAlcomScores,
  getNotificationChannels as onGetNotificationChannels
} from "../../store/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Row,
  Table,
  Spinner,
  UncontrolledAccordion, CardHeader, CardBody, Card
} from "reactstrap";

// Import the scss file
import './alcom_score_dashboard.scss'

import {
  getAlertHealth, getLogo,
} from "../../helpers/component_helpers";

const AlcomScoreDashboard = props => {
  const params = useParams()
  const dispatch = useDispatch();
  const [teams, setTeams] = useState([]);
  const [openAccordions, setOpenAccordions] = useState({});
  const [serviceAlcomScores, setServiceAlcomScores] = useState({})
  const [isLoading, setIsLoading] = useState(true);
  const [serviceFetched, setServiceFetched] = useState({})
  const [notifChannels, setNotifChannels] = useState([])
  const [unmappedResourcesAlcomScores, setUnmappedResourcesAlcomScores] = useState([])

  useEffect(() => {
    dispatch(onGetUnmappedResourceAlcomScores());
  }, [onGetUnmappedResourceAlcomScores])

  useEffect(() => {
    dispatch(onGetBluejayTeam());
  }, [onGetBluejayTeam])

  useEffect(() => {
    dispatch(onGetNotificationChannels());
  }, [onGetNotificationChannels]);

  let { current_notification_channels } = useSelector(state => ({
    current_notification_channels: state.Dashboard.notification_channels || []
  }));

  const { unmapped_resources_alcom_scores } = useSelector(state => ({
    unmapped_resources_alcom_scores: state.AlcomScoreDashboard.unmapped_resource_alcom_scores || []
  }));

  useEffect(() => {
    setNotifChannels(current_notification_channels)
  }, [current_notification_channels])

  useEffect(() => {
    setUnmappedResourcesAlcomScores(unmapped_resources_alcom_scores)
  }, [unmapped_resources_alcom_scores]);

  const { bluejayTeams } = useSelector(state => ({
    bluejayTeams: state.Organization.bluejay_teams || []
  }))

  const { teamAlcomScores } = useSelector(state => ({
    teamAlcomScores: state.AlcomScoreDashboard.team_alcom_scores || {}
  }))

  const { alcomScoresService } = useSelector(state => ({
    alcomScoresService: state.AlcomScoreDashboard.service_alcom_scores || {}
  }))

  useEffect(() => {
    if (bluejayTeams.length > 0) {
      let team_ids = bluejayTeams.map(team => team.id);
      dispatch(onGetTeamAlcomScores(team_ids));
    }
    // Set all open accordions of team_id to false
    let openAccordions = {};
    bluejayTeams.forEach(team => {
      openAccordions[team.id] = false;
    });
    setOpenAccordions(openAccordions);
  }, [bluejayTeams]);

  useEffect(() => {
    if (teamAlcomScores) {
      setTeams(teamAlcomScores);
    }
  }, [teamAlcomScores]);

  useEffect(() => {
    if (Object.keys(teams).length >= 0) {
      setIsLoading(false);
    }
  }, [teams])

  useEffect(() => {
    const updatedScores = { ...serviceAlcomScores };

    Object.entries(alcomScoresService).forEach(([serviceId, serviceData]) => {
      updatedScores[serviceId] = serviceData;
    });

    setServiceAlcomScores(updatedScores);
  }, [alcomScoresService])

  // useEffect(() => {
  //   setTeams(teams)
  // }, [serviceAlcomScores])


  const handleAccordionOpen = (teamId, services) => {
    // switch to true for that teamId
    let newOpenAccordions = { ...openAccordions };
    newOpenAccordions[teamId] = !newOpenAccordions[teamId];
    Object.keys(newOpenAccordions).forEach(key => {
      if (key !== teamId) {
        newOpenAccordions[key] = false;
      }
    });

    setOpenAccordions(newOpenAccordions);

    if (newOpenAccordions[teamId] === true) {

      let serviceIds = services.map(service => service.id)

      // Check if serviceAlcomScores has all the service ids
      let hasAllServiceIds = true

      for (let i = 0; i < serviceIds.length; i++) {
        if (!(serviceIds[i] in serviceFetched)) {
          hasAllServiceIds = false;
          break;
        }
      }

      if (!hasAllServiceIds) {
        dispatch(onGetServiceAlcomScores(serviceIds))
      }

      const updatedFetched = { ...serviceFetched };

      for (let i = 0; i < serviceIds.length; i++) {
        updatedFetched[serviceIds[i]] = true;
      }

      setServiceFetched(updatedFetched)

    }

  };

  return (
      <React.Fragment>
        <Row className="d-flex justify-content-start">
          <Col lg="8">
            <Breadcrumbs
                title={"Alcom scores dashboard"}
                breadcrumbItem={"Alcom scores dashboard"}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-start">
          <Col lg="8">
            <h5>ALCOM score by Team and Service</h5>
          </Col>
        </Row>
          <div style={{ width: '60%' }}>
            <Row className="d-flex justify-content-start w-100">
              <Col lg={12}>
                <UncontrolledAccordion>
                  {isLoading ? (
                          <Spinner className="ms-2 spinner-container" color="primary"/>
                      ) :
                      Object.keys(teams).length === 0 ? (
                              <p>No teams available. Create teams and add services to teams to view ALCOM scores in team and
                                service level.</p>
                          ) :
                          Object.entries(teams).map(([teamId, teamData], index) => (
                              <Fragment key={index}>
                                <AccordionItem>
                                  <AccordionHeader targetId={(index + 1).toString()}
                                                   onClick={() => {
                                                     handleAccordionOpen(teamId, teamData?.team?.services);
                                                   }}>
                                    <Row className="full-width">
                                      <Col lg="6">
                                        <h5 className="change-table-text text-left" style={{margin: '0px'}}>
                                          {teamData.team.name}
                                        </h5>
                                      </Col>
                                      <Col lg="6">
                                        <div className="d-flex justify-content-end align-items-start">
                                          <img
                                              src={getAlertHealth(teamData.actual_alerts, teamData.expected_alerts - teamData.actual_alerts)}
                                              style={{width: '15px', height: '15px', marginRight: '10px'}}/>
                                          <h5 style={{margin: '0px'}}>
                                            ALCOM Score: {teamData.alcom_score} %
                                          </h5>
                                        </div>
                                      </Col>
                                    </Row>
                                  </AccordionHeader>
                                  <AccordionBody accordionId={(index + 1).toString()}>
                                    {teamData?.team?.services?.map((service, index) => {
                                      const alcomScore = serviceAlcomScores[service.id]?.alcom_score;
                                      const monitoringSystems = serviceAlcomScores[service.id]?.monitoring_systems;
                                      return (
                                          <>
                                            {monitoringSystems && (
                                                <div>
                                                  <div key={index} className="service-row">
                                                    <div className="service-name">{service.name}</div>
                                                    <div className="service-alcom-score">ALCOM Score: {alcomScore} %
                                                    </div>

                                                  </div>

                                                  <div className="w-100 table-card justify-content-center" style={{ overflowY: "auto", maxHeight: "400px", overflowX: 'hidden' }}>
                                                    <Row className="d-flex justify-content-center w-100">
                                                      <Col lg={12}>
                                                    <CardHeader className="mb-3">
                                                      <CardBody>
                                                      <Row className="align-items-center">
                                                        <Col md="5" className="text-center">Monitoring System</Col>
                                                        <Col md="3" className="text-center">ALCOM Status</Col>
                                                        <Col md="4" className="text-center">ALCOM Score</Col>
                                                      </Row>
                                                      </CardBody>
                                                    </CardHeader>
                                                      </Col>
                                                    </Row>
                                                    {
                                                      Object.entries(monitoringSystems).map(([systemName, systemData], index2) => (
                                                        <Row className="d-flex justify-content-center w-100 mb-3" key={index2} >
                                                          <Col lg={12}>
                                                        <CardHeader>
                                                          <CardBody>
                                                            <Row className="align-items-center">
                                                              <Col md="2" className="text-center">
                                                                <img src={getLogo(systemName)} style={{
                                                                  width: '30px',
                                                                  height: '30px',
                                                                  marginRight: '10px'
                                                                }}/>
                                                              </Col>
                                                              <Col md="3" className="text-center">
                                                                {
                                                                  systemName === MONITORING_SYSTEMS.AWS ? (
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index}
                                                                                             to={"/cloud-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index}
                                                                                             to={"/cloud-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index}
                                                                                             to={"/cloud-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) : (
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.GCP ? (
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index}
                                                                                             to={"/gcp-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index}
                                                                                             to={"/gcp-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index}
                                                                                             to={"/gcp-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) : (
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.NewRelic ? (
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index}
                                                                                             to={"/new-relic-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index}
                                                                                             to={"/new-relic-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index}
                                                                                             to={"/new-relic-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) : (
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.Datadog ? (
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index}
                                                                                             to={"/datadog-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index}
                                                                                             to={"/datadog-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index}
                                                                                             to={"/datadog-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) : (
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.Azure ?(
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index} to={"/azure-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index} to={"/azure-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index} to={"/azure-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) :(
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.AppDynamics ?(
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index} to={"/appdynamics-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index} to={"/appdynamics-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index} to={"/appdynamics-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) :(
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.Splunk ?(
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index} to={"/splunk-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index} to={"/splunk-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index} to={"/splunk-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) :(
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : systemName === MONITORING_SYSTEMS.Dynatrace ?(
                                                                      notifChannels.length > 0 ? (
                                                                          notifChannels.map((notification_channel, index) => {
                                                                            if (notification_channel.is_primary === true) {
                                                                              if (notification_channel.name === "Email") {
                                                                                return <Link key={index} to={"/dynatrace-resources?application_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "PagerDuty") {
                                                                                return <Link key={index} to={"/dynatrace-resources?pagerduty_service_ids=" + service.id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              } else if (notification_channel.name === "OpsGenie") {
                                                                                return <Link key={index} to={"/dynatrace-resources?opsgenie_team_ids=" + service.opsgenie_team_id}
                                                                                             className="link-primary">{systemName}</Link>
                                                                              }
                                                                            }
                                                                          })
                                                                      ) :(
                                                                          <span>{systemName}</span>
                                                                      )
                                                                  ) : (
                                                                      <span>{systemName}</span>
                                                                  )
                                                                }
                                                              </Col>
                                                              <Col md="3" className="text-center">
                                                                <img
                                                                  src={getAlertHealth(systemData?.actual_alerts, systemData?.expected_alerts - systemData?.actual_alerts)}
                                                                  style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    marginRight: '10px'
                                                                  }}/>
                                                              </Col>
                                                              <Col md="4" className="text-center">
                                                                {systemData?.alcom_score} %
                                                              </Col>
                                                            </Row>
                                                          </CardBody>
                                                        </CardHeader>
                                                          </Col>
                                                        </Row>
                                                      ))
                                                    }
                                                  </div>
                                                </div>
                                            )}
                                          </>
                                      )
                                    })}
                                    </AccordionBody>
                                </AccordionItem>
                              </Fragment>
                          ))

                  }
                </UncontrolledAccordion>
              </Col>
            </Row>
          </div>
        <br/>
        <br/>
        {unmappedResourcesAlcomScores && unmappedResourcesAlcomScores.length > 0 && (
          <div>
            <Row className="d-flex justify-content-start">
              <Col lg="6">
                <h5>ALCOM score for Unmapped Resources</h5>
              </Col>
            </Row>

            <div>
              <div className="w-100 table-card justify-content-center" style={{ overflowY: "auto", maxHeight: "400px" }}>
                <Row className="d-flex justify-content-center w-100">
                  <Col lg={12}>
                    <CardHeader className="mb-3">
                      <Row className="align-items-center">
                        <Col md="3" className="text-center">Monitoring System</Col>
                        <Col md="7" className="text-center">Resource Name</Col>
                        <Col md="2" className="text-center">ALCOM Score</Col>
                      </Row>
                    </CardHeader>
                    {unmappedResourcesAlcomScores.map((resource, index) => (
                      <CardHeader key={index} className="mb-3">
                        <CardBody style={{ overflowX: 'hidden' }}>
                          <Row className="align-items-center">
                            <Col md="1" className="d-flex align-items-center justify-content-center">
                              <img src={getLogo(resource.monitoring_system)} className="resource-logo" style={{ width: '30px', height: '30px', marginRight: '10px' }} />
                            </Col>
                            <Col md="2" className="d-flex align-items-center justify-content-center">
                              {resource.monitoring_system}
                            </Col>
                            <Col md="7" className="d-flex align-items-center">
                              <img
                                src={getAlertHealth(resource?.actual_alert_count, resource?.expected_alert_count - resource?.actual_alert_count)}
                                style={{ width: '15px', height: '15px', marginRight: '10px' }}
                              />
                              {resource.monitoring_system === MONITORING_SYSTEMS.AWS ? (
                                <Link to={`/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.GCP ? (
                                <Link to={`/gcp/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.NewRelic ? (
                                <Link to={`/newrelic/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.Datadog ? (
                                <Link to={`/datadog/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.Azure ? (
                                <Link to={`/azure/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.AppDynamics ? (
                                <Link to={`/appdynamics/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.Splunk ? (
                                <Link to={`/splunk/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.Dynatrace ? (
                                <Link to={`/dynatrace/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ) : resource.monitoring_system === MONITORING_SYSTEMS.Grafana ? (
                                  <Link to={`/grafana/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ): resource.monitoring_system === MONITORING_SYSTEMS.Signoz ? (
                                  <Link to={`/signoz/resource/${resource.resource_id}/alerts`}>{resource.resource_name}</Link>
                              ):(
                                <span>{resource.resource_name}</span>
                              )}
                            </Col>
                            <Col md="2" style={{ textAlign: 'center' }}>
                              {resource.alcom_score} %
                            </Col>
                          </Row>
                        </CardBody>
                      </CardHeader>
                    ))}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
  );
};

AlcomScoreDashboard.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(AlcomScoreDashboard);
